<script setup lang="ts">
import { PanelLeftClose, PanelLeftOpen } from 'lucide-vue-next'
import NavMain from './nav/NavMain.vue'
import { Sidebar, SidebarContent, SidebarHeader } from '@/components/ui/sidebar'
import { Button } from '@/components/ui/button'
import { useSidebar } from '@/components/ui/sidebar/useSidebar'

const { open, toggleSidebar } = useSidebar()
</script>

<template>
  <Sidebar>
    <SidebarHeader>
      <Button
        variant="ghost"
        size="default"
        class="w-full justify-start gap-2 group-data-[collapsible=icon]/sidebar:justify-center group-data-[collapsible=icon]/sidebar:px-0"
        @click="toggleSidebar"
      >
        <component :is="open ? PanelLeftClose : PanelLeftOpen" class="h-4 w-4" />
        <span class="group-data-[collapsible=icon]/sidebar:hidden">
          {{ open ? 'Close Sidebar' : 'Open Sidebar' }}
        </span>
      </Button>
    </SidebarHeader>
    <SidebarContent>
      <NavMain />
    </SidebarContent>
  </Sidebar>
</template>
